(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightPunctuality.controller:DelayCodesModalCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('flightPunctuality')
		.controller('flightLogDetailsPopupCtrl', flightLogDetailsPopupCtrl);

	function flightLogDetailsPopupCtrl($uibModalInstance, modalParams, FlightPunctualityService) {
		var vm = this;

		vm.model = {
      flightLeg: modalParams.flightLeg,
      flightLog:[]
		};

		vm.closeMe = function() {
			$uibModalInstance.close();
		};

    (function loadJoiningCrewDetails() {
      FlightPunctualityService.getFlightLogDetails(vm.model.flightLeg.FLI, function (flightLogDetailsListRS) {
        vm.model.flightLog = flightLogDetailsListRS.flightLogDetailsDTOS;
      }, function () {
        console.log('Error retrieving FlightLog Deatils ');
      });
    })();
	}
}());
